import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class CancelSuscTask extends AbstractRequestTask {
  constructor(params) {
    super();

    this.params = params;
  }

  getHeaders() {
    const params = super.getParams();
    return {
        'Content-Type': 'application/json',
        'user-token': params.user_token
    };
  }

  getUrl() {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/payway/v1/cancelsuscription`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.user_token;
    delete params.api_version;
    return {
      ...this.params,
      ...params,
    };
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default CancelSuscTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/CancelSuscTask.js